export default "__VITE_PUBLIC_ASSET__8432c4ad__"